import React from 'react';

export const GlobalStyles: React.FC = () => {
    return (
        <style>{`
            * {
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                word-wrap: break-word;
                overflow-wrap: break-word;
                hyphens: none;
            }
            
            h1, h2, h3, h4, h5, h6 {
                letter-spacing: -0.02em;
                word-break: keep-all;
            }
            
            body, p, span, div, a, label, button {
                letter-spacing: -0.01em;
                word-break: keep-all;
            }
            
            @keyframes fadeInUp {
                from {
                    opacity: 0;
                    transform: translateY(30px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }

            @keyframes fadeInLeft {
                from {
                    opacity: 0;
                    transform: translateX(-50px);
                }
                to {
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            @keyframes fadeInRight {
                from {
                    opacity: 0;
                    transform: translateX(50px);
                }
                to {
                    opacity: 1;
                    transform: translateX(0);
                }
            }

            @keyframes laser {
                0% {
                    transform: translateX(-200px);
                }
                100% {
                    transform: translateX(calc(100vw + 200px));
                }
            }

            .fade-in-up {
                animation: fadeInUp 0.6s ease-out forwards;
            }

            .fade-in-left {
                animation: fadeInLeft 0.6s ease-out forwards;
            }

            .fade-in-right {
                animation: fadeInRight 0.6s ease-out forwards;
            }

            .fade-in {
                animation: fadeIn 0.6s ease-out forwards;
            }

            .laser-beam {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 200px;
                background: rgba(255, 255, 255);
                filter: blur(0.3px);
                animation: laser 3s linear infinite;
                pointer-events: none;
            }

            .title-letter {
                display: inline-block;
                font-weight: inherit;
            }

            .letter-scrambled {
                opacity: 0;
                transform: translate(var(--random-x, 0), var(--random-y, 0));
            }

            @keyframes letterAlign {
                0% {
                    opacity: 0;
                    transform: translate(var(--random-x, 0), var(--random-y, 0));
                }
                50% {
                    opacity: 0;
                    transform: translate(var(--random-x, 0), var(--random-y, 0));
                }
                70% {
                    opacity: 1;
                    transform: translate(0, 0);
                }
            }

            .animate-letter-align {
                animation: letterAlign 2.1s ease-out forwards;
            }
        `}</style>
    );
};

